import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {KennethMustDie} from "../KennethMustDie";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {gsap} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {KMDSound} from "../sound/KMDSound";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";

export class KMDCar extends PIXI.Container implements StageLayer {
    private _barbieCar: PIXI.spine.Spine;
    private _kenCar: PIXI.spine.Spine;
    private _beefyCar: PIXI.spine.Spine;
    private _tl: gsap.core.Timeline;
    private _prevBarbieDriveBySound: string;
    private _prevKenDriveBySound: string;
    private _prevBeefyDriveBySound: string;

    constructor() {
        super();
        this.name = "KMDCar";

        this.init();
    }

    public playCar(): void {
        const num: number = MathHelper.randomIntInRange(1, 100),
            delay: number = MathHelper.randomIntInRange(5, 10),
            duration: number = MathHelper.randomIntInRange(3, 5),
            carIdx: number = MathHelper.randomIntInRange(0, 1);
        let item: PIXI.spine.Spine,
            sound: string;

        this._tl = gsap.timeline();

        if (num % 5 === 0) {
            item = this._beefyCar;

            sound = ArrayHelper.getRandomValue(KMDSound.DRIVE_BY_BEEFY);
            while (sound === this._prevBeefyDriveBySound) {
                sound = ArrayHelper.getRandomValue(KMDSound.DRIVE_BY_BEEFY);
            }
            this._prevBeefyDriveBySound = sound;
        } else if (carIdx === 1) {
            item = this._kenCar;

            sound = ArrayHelper.getRandomValue(KMDSound.DRIVE_BY_KEN);
            while (sound === this._prevKenDriveBySound) {
                sound = ArrayHelper.getRandomValue(KMDSound.DRIVE_BY_KEN);
            }
            this._prevKenDriveBySound = sound;
        } else {
            item = this._barbieCar;

            sound = ArrayHelper.getRandomValue(KMDSound.DRIVE_BY_BARBIE);
            while (sound === this._prevBarbieDriveBySound) {
                sound = ArrayHelper.getRandomValue(KMDSound.DRIVE_BY_BARBIE);
            }
            this._prevBarbieDriveBySound = sound;
        }

        this._tl.add(() => {
            item.x = NolimitApplication.screenBounds.right + 200;
            item.visible = true;
            item.updateTransform();

            item.state.setAnimation(0, "animation", true);

            // #431
            if (NolimitApplication.isLandscape) {
                // #414
                KennethMustDie.soundPlayer.playSound(sound);
            }

            gsap.to(item, {
                x: NolimitApplication.screenBounds.left - 400,
                duration: duration,
                onComplete: () => {
                    item.visible = false;
                    item.state.clearTracks();
                }
            });
        }, delay);

        this._tl.add(() => {
            this.playCar();
        }, delay + duration);
    }

    public stopCar(): void {
        if (this._tl) {
            this._tl.pause();
            this._tl.kill();
        }
    }

    private init(): void {
        this._barbieCar = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("barbieCar"));
        this._barbieCar.visible = false;
        this._barbieCar.y = 485;

        this._kenCar = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("kenCar"));
        this._kenCar.visible = false;
        this._kenCar.y = 370;

        this._beefyCar = new PIXI.spine.Spine(KennethMustDie.assetLoader.getSpineAsset("beefyCar"));
        this._beefyCar.visible = false;
        this._beefyCar.y = 370;

        this.addChild(this._barbieCar, this._kenCar, this._beefyCar);
    }
}